import {LABELS} from './constants/labels'
import {IssueTemplateItem} from './IssueTemplateItem'
import {BLANK_ISSUE_ID, IssueCreationKind} from './utils/model'
import {getTemplateUrl} from './utils/urls'

type BlankIssueItemProps = {
  onTemplateSelected?: (filename: string, kind: IssueCreationKind) => void
  nameWithOwner: string
  isMaintainerOverride?: boolean
}

export const BlankIssueItem = ({
  nameWithOwner,
  onTemplateSelected,
  isMaintainerOverride,
}: BlankIssueItemProps): React.ReactElement => {
  return (
    <IssueTemplateItem
      filename={BLANK_ISSUE_ID}
      onTemplateSelected={() => onTemplateSelected?.(BLANK_ISSUE_ID, IssueCreationKind.BlankIssue)}
      name={LABELS.blankIssueName}
      about={LABELS.blankIssueDescription}
      inlineLabel={isMaintainerOverride ? LABELS.blankIssueMaintainerLabel : undefined}
      link={onTemplateSelected ? undefined : getTemplateUrl(nameWithOwner, BLANK_ISSUE_ID)}
    />
  )
}
